import { Header, MessageReceipt as MessageReceiptComponent } from "components"
export const MessageReceipt = () => {
 return (
  <div>
   <Header />
   <MessageReceiptComponent />
  </div>
 )
}
